<template>
	<div>
		<buttonlist ref="SetBtn" @help="help" @search="search" @reflash="reflash" @exps="exp"></buttonlist>
		<div id="xpane-0">
			<vxe-table :data="dataBody" size="mini" :loading="loading" header-cell-class-name="headerclass" :height="tableHeight" stripe border resizable>
				<vxe-table-column type="checkbox" align="center" width="30"></vxe-table-column>

				<vxe-table-column show-footer-overflow v-for="item in dataHeader" :key="item._key" :field="item._key" :title="item._value" :align="item._key == 'part_code'?'left':'right'" width="200" show-overflow="tooltip">
					<template scope="scope" >
						<span v-if="item._key != 'part_code'">{{ scope.row[item._key] | thousandth}}</span>
						<span v-else>{{ scope.row[item._key]}}</span>
					</template>
				</vxe-table-column>
			</vxe-table>
		</div>

		<serce :isVisible="isVisible" queryData="SalGPM" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_salgpm',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], //
                dataHeader: [],
                dataBody: [],
                loading: false,
                SelectIndex: 0,
                // 系统外成本
                activeName: '0', // 当前选择的分页
                isVisible: false,
                queryData:[],
            };
        },
        beforeDestroy(){
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function(){
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                });
            },
        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[9818]"),this.$t("getapi[8045]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            },
            reflash(){
                let that = this
                that.search()
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SalGPM');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            //查询
            getView(){
                let that = this
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: 1,
                    PageSize: 100000,
                    SelectIndex: 1,
                    Param: datac
                };
                that.$http.urlpost('/CostCalc/InvView/GetSalGPM', data, function (res) {
                    if (res.Success == 1) {
                        that.dataHeader = res.Titles;
                        that.dataBody = res.DataContent;
                    }
                })
            },
            exp(){
                let that = this
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: 1,
                    PageSize: 100000,
                    SelectIndex: 1,
                    Param: datac
                };
                that.$http.urlpost('/CostCalc/InvView/GetSalGPMToExcel', data, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
        }
    };
</script>

<style scoped lang="less">
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
	.tab{
		border-spacing: 20px;
		font-size: 18px;
	}
	.el-table--mini, .el-table--small, .el-table__expand-icon{
		border: 1px solid #9cc1f5
	}
</style>
